import Storage from '@mui/icons-material/Storage';
import Warning from '@mui/icons-material/Warning';
import { CircularProgress } from '@mui/material';
import { TableAction } from '@/stores/FixtureStore';
import { ACTION_STATE, ActionState } from '@/stores/constants';
import { Dot } from '../Dot/Dot';

type ColumnId = keyof TableAction;
export type ActionTableColumn = {
  id: ColumnId;
  name: JSX.Element | string;
  width: number;
};

export const COLUMNS: ActionTableColumn[] = [
  { id: 'period', name: 'Period', width: 7 },
  { id: 'time', name: 'Time', width: 7 },
  { id: 'type', name: 'Event', width: 20 },
  { id: 'player', name: 'Player', width: 10 },
  { id: 'extras', name: 'Extras', width: 24 },
  { id: 'isSuccessful', name: 'Outcome', width: 20 },
  { id: 'warnings', name: <Warning fontSize='small' />, width: 2 },
  { id: 'state', name: <Storage fontSize='small' />, width: 10 },
];

(function () {
  const totalWidth = COLUMNS.reduce((acc, col) => {
    return acc + col.width;
  }, 0);
  if (totalWidth !== 100) {
    console.error(
      `ActionsTable columns width is ${totalWidth}% - should be a 100%`,
    );
  }
})();

export const TABLE_CLASS_NAMES = {
  ROW: 'action-row',
};

export const TABLE_ACTION_STATE_ICON: Record<ActionState, JSX.Element> = {
  [ACTION_STATE.NONE]: <span data-state={ACTION_STATE.NONE}></span>,
  [ACTION_STATE.ERROR]: (
    <Dot data-state={ACTION_STATE.ERROR} color='red' size='1em'></Dot>
  ),
  [ACTION_STATE.SYNC]: (
    <CircularProgress data-state={ACTION_STATE.SYNC} size='1em' />
  ),
  [ACTION_STATE.SUCCESS]: (
    <Dot data-state={ACTION_STATE.SUCCESS} color='green' size='1em'></Dot>
  ),
} as const;
